var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" Choose Report "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c("li", [
              _c("div", { staticClass: "field has-addons" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reportType,
                      expression: "reportType",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    checked: "",
                    id: "detailed",
                    type: "radio",
                    name: "reportType",
                    value: "detailed",
                  },
                  domProps: { checked: _vm._q(_vm.reportType, "detailed") },
                  on: {
                    change: function ($event) {
                      _vm.reportType = "detailed"
                    },
                  },
                }),
                _c("label", { attrs: { for: "detailed" } }, [
                  _vm._v("Detailed Report"),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reportType,
                      expression: "reportType",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    id: "summary",
                    type: "radio",
                    name: "reportType",
                    value: "summary",
                  },
                  domProps: { checked: _vm._q(_vm.reportType, "summary") },
                  on: {
                    change: function ($event) {
                      _vm.reportType = "summary"
                    },
                  },
                }),
                _c("label", { attrs: { for: "summary" } }, [
                  _vm._v("Summary Report"),
                ]),
              ]),
            ]),
          ]),
          _c("hr"),
          _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  on: { click: _vm.onOkClick },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-file-document mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Show")]),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }